import { useQuery } from '@apollo/client';
import { useNotifications } from '@risksmart-app/components/src/notifications/useNotifications';
import type { Control_Bool_Exp } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  GetControlsDocument,
  Parent_Type_Enum,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import useEntityWhereFilter from '@/hooks/useEntityWhereFilter';
import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import { useGetControlsRegister as useGetControlsRegisterTRPC } from './useGetControlsRegisterTRPC';

export const useGetControlsRegister = (parentId?: string, skip?: boolean) => {
  const trpcEnabled = useIsFeatureVisibleToOrg('trpc');
  const { addNotification } = useNotifications();

  const entityFilterWhere = useEntityWhereFilter<Control_Bool_Exp>(
    Parent_Type_Enum.Control
  );
  const parentWhere: Control_Bool_Exp = {
    parents: {
      ParentId: { _eq: parentId },
    },
  };

  const {
    data: graphqlData,
    loading: graphqlLoading,
    refetch: graphqlRefetch,
  } = useQuery(GetControlsDocument, {
    variables: { where: parentId ? parentWhere : entityFilterWhere },
    fetchPolicy: 'no-cache',
    skip: trpcEnabled || skip, // Skip GraphQL query when TRPC is enabled
    onError: (error) => {
      if (!trpcEnabled) {
        addNotification({
          type: 'error',
          content: <>{error.message}</>,
        });
      }
    },
  });

  const {
    data: trpcData,
    loading: trpcLoading,
    refetch: trpcRefetch,
  } = useGetControlsRegisterTRPC(parentId, skip);

  // Return appropriate data based on feature flag
  if (trpcEnabled) {
    return {
      loading: trpcLoading,
      data: trpcData,
      refetch: () => trpcRefetch(),
    };
  }

  return {
    loading: graphqlLoading,
    data: graphqlData,
    refetch: () => graphqlRefetch(),
  };
};
